<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <jm-toolbar customize-field-name="" v-if="$hasPermission([62, 173, 123])">
          <el-button
            slot="beforeDefinedSearch"
            type="success"
            @click="addQuestion">添加问答</el-button>
        </jm-toolbar>
        <el-form
          :inline="true"
          :model="searchData">
          <el-form-item label="所属国家">
            <el-select v-model="searchData.country" clearable placeholder="请选择">
              <el-option
                v-for="item in ds.country"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <div>
                  <img :src="item.flag" height="22" align="absmiddle" /> &nbsp; {{ item.name }}
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input v-model="searchData.keyword" clearable placeholder="关键字" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="() => {this.refresh = true;}">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="collapseAll">展开所有</el-checkbox>
          </el-form-item>
        </el-form>

        <div v-loading="loading" element-loading-text="Loading...">
          <el-collapse v-model="collapseNames" v-if="tableData.data">
            <el-collapse-item
              v-for="item in tableData.data"
              :title="item.title"
              :name="item.id"
              :key="item.id"
            >
              <template slot="title">
                <table width="100%">
                  <tr>
                    <td>
                      <img :src="item.country_flag" height="24" align="absmiddle" :title="item.country_name" />
                      <el-tag type="primary" size="mini">{{ item.country_name }}</el-tag>
                      &nbsp;
                      {{ item.title }}
                    </td>
                    <td class="collapse-buttons" v-if="$hasPermission([62, 173, 123])">
                      <el-button size="mini" type="primary" icon="el-icon-edit" title="编辑" @click.stop="editQuestion(item)" round></el-button>
                      <el-button size="mini" type="danger" icon="el-icon-delete" title="删除" @click.stop="deleteQuestion(item)" round></el-button>
                    </td>
                  </tr>
                </table>
              </template>
              <div class="collapse-content">{{ item.content }}</div>
            </el-collapse-item>
          </el-collapse>

          <!--分页-->
          <div v-if="tableData.total > 0" class="flip-area">
            <el-pagination
              :current-page.sync="internalCurrentPage"
              :page-size="internalPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="amount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
          <div v-else style="padding:40px;text-align:center;">
            暂无数据
          </div>
        </div>
      </div>
    </div>

    <!--start:新增、编辑对话框-->
    <el-dialog
      :title="formData.id === 0 ? '新增问题' : '修改问题'"
      v-model="formData"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <el-form label-width="80px" :rules="rules" ref="formData" :model="formData">
        <el-form-item label="所属国家" prop="country">
          <el-select v-model="formData.country" placeholder="请选择">
            <el-option
              v-for="item in ds.country"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题(Q)" prop="title">
          <el-input v-model="formData.title" autofocus clearable></el-input>
        </el-form-item>
        <el-form-item label="解答(A)" prop="content">
          <el-input v-model="formData.content" autofocus type="textarea" rows="8"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('formData')">提 交</el-button>
      </span>
    </el-dialog>
    <!--end:新增、编辑对话框-->
  </div>
</template>

<style>
  .el-dialog{
    width: 30%;
    min-width: 450px;
  }
  .el-form-item {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-collapse-item__header{
    height: auto;
    line-height: 200%;
    min-height:48px;
    padding-top:10px;
    padding-bottom:10px;
  }
  .collapse-buttons{
    width:80px; text-align: center; vertical-align: middle;
  }
  .collapse-buttons button.el-button--mini{
    padding:7px 7px;
  }
  .collapse-content{
    padding:10px 20px;
    white-space: pre-wrap;
  }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';

export default {
  data() {
    return {
      refresh: false,
      loading: false,
      dialogVisible: false,
      collapseAll: false,
      collapseNames: [],

      ds: {},
      searchData: {
        keyword: '',
        country: ''
      },
      formData: {
        id: 0,
        title: '',
        country: '',
        content: '',
      },

      tableData: {
        data: null
      },
      amount: null,
      sortData: {},
      internalCurrentPage: 1,
      internalPageSize: 10,
      rules: {
        // country: [
        //   { required: true, message: '请选择所属国家', trigger: 'blur' }
        // ],
        title: [
          { required: true, message: '请输入问题标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入解答内容', trigger: 'blur' }
        ]
      },
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
  },
  methods: {
    addQuestion() {
      this.dialogVisible = true;
    },
    editQuestion(item) { // 编辑
      this.dialogVisible = true;
      this.formData = item;
      this.formData.country = String(item.country);
    },
    deleteQuestion(item) { // 删除
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/europe_question/delQuestion',
          data: { id: item.id },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.refresh = true;
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (typeof this.formData.id === 'undefined') {
            this.formData.id = 0;
          }

          this.$http._post({
            url: '/index/europe_question/saveQuestion',
            data: this.formData,
          }).then((res) => {
            if (res.result === 0) {
              this.$message({
                type: 'success',
                message: this.formData.id === 0 ? '问答创建成功' : '问答修改成功'
              });
              this.resetSearch();
            }
          });
        } else {
          this.$message.error('带 * 的项目必须填写');
          return false;
        }
      });
    },
    resetSearch(refresh = true) {
      this.formData = {
        id: 0,
        title: '',
        country: '',
        content: '',
      };
      this.searchData = {
        keyword: '',
        country: ''
      };
      this.sortData = {};
      this.internalCurrentPage = 1;
      this.internalPageSize = 10;
      this.dialogVisible = false;
      this.refresh = refresh;
    },
    setCollapseStatus(v) {
      if (v === true) {
        if (this.tableData.data) {
          this.collapseNames = this.tableData.data.map((item) => {
            return item.id;
          });
        }
      } else {
        this.collapseNames = [];
      }
    },
    fetchData() {
      this.$http
        ._get({
          url: '/index/europe_question/dictData'
        })
        .then(({ data }) => {
          this.ds = data;
        });
    },
    /**
     * 请求数据实现翻页
     */
    getTableData(
      currentPage = this.internalCurrentPage,
      pageSize = this.internalPageSize,
      amount = this.amount
    ) {
      this.loading = true;
      return this.$http
        ._post({
          url: `/index/europe_question/getQuestionList${this.noPagination ? '' : `?page=${currentPage}`}`,
          data: {
            ...this.postData,
            pageSize,
            amount,
            sortData: this.sortData,
            searchData: this.searchData
          }
        })
        .then(({ data }) => {
          this.tableData = data;
          this.amount = data.total;
          this.internalPageSize = pageSize;
          this.loading = false;
          this.refresh = false;

          // 根据展开状态更新
          this.setCollapseStatus(this.collapseAll);
        })
        .catch((data) => {
          if (data.data.code === 4004) {
            setTimeout(() => {
              window.opener = null;
              window.open('', '_self');
              window.close();
            }, 2000);
          }
        });
    },
    /**
     * pageSize 改变时会触发
     */
    handleSizeChange(size) {
      this.getTableData(this.internalCurrentPage, size);
    },
    /**
     * currentPage 改变时会触发
     */
    handleCurrentChange(currentPage) {
      !this.refresh && this.getTableData(currentPage, this.internalPageSize);
    },
  },
  mounted() {
    this.$nextTick(function() {
      this.getTableData();
    });
    this.fetchData();
  },
  watch: {
    refresh(v) {
      if (v === true) {
        this.getTableData();
      }
    },
    dialogVisible(v) {
      if (v === false && this.formData.id > 0) {
        this.formData = {
          id: 0,
          title: '',
          content: '',
          country: ''
        };
      }
    },
    collapseAll(v) {
      this.setCollapseStatus(v);
    },
  }
};
</script>
